import * as React from "react";

function SvgCircleCheckedEmpty(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C5.9 23 1 18.1 1 12S5.9 1 12 1s11 4.9 11 11-4.9 11-11 11zm0-2c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCircleCheckedEmpty;
